import Action from '../../model/Action'
import State from '../../model/State'

export function queryReducer(state: State, action: Action) {
    switch (action.type) {
    case 'changeSearch':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, search: action.payload }
            }
        }
    case 'changePage':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, page: action.payload }
            }
        }
    case 'changeLimit':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, limit: action.payload }
            }
        }
    case 'changeArea':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, area: action.payload }
            }
        }
    case 'changeCity':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, city: action.payload }
            }
        }
    case 'changeType':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, type: action.payload }
            }
        }
    case 'changeAdmin':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, admin: action.payload }
            }
        }
    case 'changeQuery':
        return {
            ...state,
            entidades: {
                ...state.entidades,
                query: { ...state.entidades.query, ...action.payload }
            }
        }
    default:
        return state
    }
}
